import { createResourceStore } from '@next-qr/lib-ui/store';
import { forwardApi } from './api';

export const useForwardStore = createResourceStore(forwardApi);
